// src/domains/withdraw.keys.ts —— 模板键归属（TD-823，agent-keys 用例按片 owner 推导核对）
// walletTip / wdTxt 来自片 0131 的 R-08 / R-04 / D9 偏差块；原型 unsettledText / lifetimeText 随 GAP-28 删除
export const KEYS = [
  'amountChips', 'arriveText', 'availableText', 'isUsdt', 'methods', 'onWAddr', 'onWAmount', 'submitWithdraw', 'wAddr', 'wAmount', 'wFee', 'wNet',
  'withdrawEmpty', 'withdrawals', 'walletTip', 'wdTxt',
] as const;
export const MODAL_KEYS = [] as const;
